import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import moment from "moment";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import WarningIcon from "@material-ui/icons/Warning";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import InfoIcon from "@material-ui/icons/Info";
import Tooltip from "@material-ui/core/Tooltip";
import SuperLedgerPaymentStatus from "../../components/superPay/SuperLedgerPaymentStatus";

import currencyHelper from "../../helper/currency";
import ResponsiveTable from "../../components/table/ResponsiveTable";
import { ProfileType, SuperLedgerStatus, BookingType } from "../../types/enum";


const STATUS_OPTIONS = [
    { value: "", label: "All Statuses" },
    { value: SuperLedgerStatus.Pending.ordinal, label: "Pending" },
    { value: SuperLedgerStatus.Processing.ordinal, label: "Processing" },
    { value: SuperLedgerStatus.Posted.ordinal, label: "Posted" },
    { value: SuperLedgerStatus.Paid.ordinal, label: "Paid" },
    { value: SuperLedgerStatus.Failed.ordinal, label: "Failed" },
    { value: SuperLedgerStatus.Refunded.ordinal, label: "Refunded" },
];

@inject("profileStore", "superLedgerStore", "templateStore", "reportStore")
@withRouter
@observer
class OutgoingLedgers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            actionMenuAnchorEl: null,
            actionMenuLedger: null,
            actionMenuItem: null,
            actionMenuGroup: null
        };
    }

    componentDidMount() {}

    handleViewItems = (ledger) => {
        const { onOpenReport } = this.props;
        if (onOpenReport) {
            onOpenReport([ledger], "outgoing");
        }
    };

    handleLoadMore = () => {
        const { currentProfile } = this.props.profileStore;
        const { outgoingPage } = this.props.superLedgerStore;
        this.props.superLedgerStore.getLedgersByPayeeId(currentProfile.id, outgoingPage + 1);
    };

    handleActionMenuOpen = (event, ledger, groupOrItem) => {
        event.stopPropagation();
        const isGroup = groupOrItem && (groupOrItem.items !== undefined || groupOrItem.count !== undefined || groupOrItem.ledgerCount !== undefined);
        this.setState({
            actionMenuAnchorEl: event.currentTarget,
            actionMenuLedger: ledger || null,
            actionMenuGroup: isGroup ? groupOrItem : null,
            actionMenuItem: !isGroup ? groupOrItem : null
        });
    };

    handleActionMenuClose = () => {
        this.setState({
            actionMenuAnchorEl: null,
            actionMenuLedger: null,
            actionMenuItem: null,
            actionMenuGroup: null
        });
    };

    handleViewFromMenu = () => {
        const { actionMenuLedger, actionMenuItem, actionMenuGroup } = this.state;
        this.handleActionMenuClose();
        if (actionMenuGroup) {
            const items = actionMenuGroup.items || [];
            if (items.length > 0 && this.props.onOpenReport) {
                this.props.onOpenReport(items, "outgoing");
            }
        } else if (actionMenuItem) {
            if (this.props.onOpenReport) this.props.onOpenReport([actionMenuItem], "outgoing");
        } else if (actionMenuLedger) {
            this.handleViewItems(actionMenuLedger);
        }
    };

    handleStatusFilterChange = (event) => {
        const value = event.target.value;
        const { currentProfile } = this.props.profileStore;
        this.props.superLedgerStore.setStatusFilter(value === "" ? undefined : value);
        this.props.superLedgerStore.resetLedgerPage();
        if (currentProfile?.id) {
            const { isGrouped } = this.props.superLedgerStore;
            if (isGrouped) {
                this.props.superLedgerStore.getGroupedLedgersByPayeeId(currentProfile.id);
            } else {
                this.props.superLedgerStore.getLedgersByPayeeId(currentProfile.id, 1);
            }
        }
    };

    handleGroupToggle = (event) => {
        const grouped = event.target.checked;
        const { currentProfile } = this.props.profileStore;
        this.props.superLedgerStore.setIsGrouped(grouped);
        this.props.superLedgerStore.resetLedgerPage();
        this.props.superLedgerStore.setIsGrouped(grouped);
        if (currentProfile?.id) {
            if (grouped) {
                this.props.superLedgerStore.getGroupedLedgersByPayeeId(currentProfile.id);
            } else {
                this.props.superLedgerStore.getLedgersByPayeeId(currentProfile.id, 1);
            }
        }
    };

    getColumns = (isGrouped) => {
        if (isGrouped) {
            return [
                { key: "contactName", label: "Payer/Payee Name", sortable: true, width: "25%" },
                { key: "totalSuper", label: "Total Super Amount", sortable: true, width: "18%" },
                { key: "ledgerCount", label: "# Ledgers", width: "12%" },
                { key: "readyToPay", label: "Ready to Pay", width: "15%", align: "center" },
                { key: "status", label: "Status", width: "20%" },
                { key: "actions", label: "Actions", width: "10%" }
            ];
        }
        return [
            { key: "contactName", label: "Contact Name", sortable: true, width: "14%" },
            { key: "contactPhone", label: "Contact Phone", width: "10%" },
            { key: "relatedBooking", label: "Related Booking", width: "30%" },
            { key: "totalSuper", label: "Total Super Amount", sortable: true, width: "10%" },
            { key: "superDetails", label: "Super Pay Ready", width: "9%", align: "center" },
            { key: "readyToPay", label: "Ready to Pay", width: "9%", align: "center" },
            { key: "status", label: "Status", width: "12%" },
            { key: "actions", label: "Actions", width: "6%" }
        ];
    };

    getMusicianColumns = (isGrouped) => {
        if (isGrouped) {
            return [
                { key: "contactName", label: "Hirer Name", sortable: true, width: "30%" },
                { key: "superAmount", label: "Total Super Amount", sortable: true, width: "20%" },
                { key: "ledgerCount", label: "# Ledgers", width: "15%" },
                { key: "readyToPay", label: "Ready to Pay", width: "15%", align: "center" },
                { key: "status", label: "Status", width: "20%" }
            ];
        }
        return [
            { key: "contactName", label: "Hirer Contact Name", sortable: true, width: "18%" },
            { key: "contactPhone", label: "Contact Details", width: "12%" },
            { key: "relatedBooking", label: "Related Booking", width: "34%" },
            { key: "superAmount", label: "Super Amount", sortable: true, width: "12%" },
            { key: "status", label: "Status", width: "16%" },
            { key: "actions", label: "Actions", width: "8%" }
        ];
    };

    getCurrencySymbol = () => {
        const { currentProfile } = this.props.profileStore;
        let currencySymbol = "$";
        if (
            (currentProfile?.type === ProfileType.Musician.ordinal || currentProfile?.type === ProfileType.Agent.ordinal) &&
            currentProfile?.currency
        ) {
            currencySymbol = currentProfile?.currency === "GBP" ? "£" : "$";
        } else if (currentProfile?.type === ProfileType.Staff.ordinal) {
            if (currentProfile.hasOrganisation) {
                currencySymbol = currentProfile.organisation[0]?.currency === "GBP" ? "£" : "$";
            } else {
                currencySymbol = currentProfile.venue?.currency === "GBP" ? "£" : "$";
            }
        }
        return currencySymbol;
    };

    renderStatusChip = (status) => {
        return <SuperLedgerPaymentStatus status={status} />;
    };

    renderGroupStatusSummary = (group) => {
        return <SuperLedgerPaymentStatus group={group} />;
    };

    renderFooterRow = (ledgers, isGrouped) => {
        const currencySymbol = this.getCurrencySymbol();
        if (isGrouped) {
            const totalSuper = ledgers.reduce((sum, g) => sum + parseFloat(g.totalSuper || 0), 0);
            const totalLedgers = ledgers.reduce((sum, g) => sum + (g.items ? g.items.length : 0), 0);
            return {
                contactName: `Total (${ledgers.length} Artists, ${totalLedgers} Payments)`,
                totalSuper: currencySymbol + currencyHelper.formatMoney(totalSuper, 2),
                ledgerCount: "",
                readyToPay: "",
                status: "",
                actions: ""
            };
        }
        let totalSuper = 0;
        ledgers.forEach(ledger => { totalSuper += parseFloat(ledger.superFee || 0); });
        return {
            contactName: `Total (${ledgers.length} items)`,
            contactPhone: "",
            superDetails: "",
            totalSuper: currencySymbol + currencyHelper.formatMoney(totalSuper, 2),
            relatedBooking: "",
            readyToPay: "",
            status: "",
            actions: ""
        };
    };

    renderMusicianFooterRow = (rows, isGrouped) => {
        const currencySymbol = this.getCurrencySymbol();
        if (isGrouped) {
            const { outgoingLedgers } = this.props.superLedgerStore;
            const totalSuper = outgoingLedgers.reduce((sum, g) => sum + parseFloat(g.totalSuper || 0), 0);
            const totalLedgers = outgoingLedgers.reduce((sum, g) => sum + (g.items ? g.items.length : 0), 0);
            return {
                contactName: `Total (${outgoingLedgers.length} groups, ${totalLedgers} ledgers)`,
                superAmount: currencySymbol + currencyHelper.formatMoney(totalSuper, 2),
                ledgerCount: "",
                readyToPay: "",
                status: ""
            };
        }
        let totalSuper = 0;
        rows.forEach(row => { totalSuper += parseFloat(row._superFeeRaw || 0); });
        return {
            contactName: `Total (${rows.length} items)`,
            contactPhone: "",
            superAmount: currencySymbol + currencyHelper.formatMoney(totalSuper, 2),
            relatedBooking: "",
            status: "",
            actions: ""
        };
    };

    mapLedgerRow = (ledger, currencySymbol, paymentType) => {
        if (!ledger) return null;
        const payer = ledger.payer || {};
        const row = {};
        row.id = ledger.id;
        row._superFeeRaw = parseFloat(ledger.superFee || 0);
        row.contactName = payer.profileName
            ? payer.profileName
            : `${payer.firstName || ""} ${payer.lastName || ""}`.trim() || "Unknown";
        row.contactPhone = payer.contactPhone || "-";
        row.superAmount = currencySymbol + currencyHelper.formatMoney(row._superFeeRaw, 2);

        const booking = ledger.booking || {};
        const bookingDate = booking.dateStart && moment.utc(booking.dateStart).isValid()
            ? moment.utc(booking.dateStart).format("DD MMM YYYY")
            : null;
        const bookingTitle = booking.title || booking.name || null;
        const bookingId = booking.id || null;
        const bookingLabel = [bookingDate, bookingTitle].filter(Boolean).join(" - ") || "-";
        const bookingPath = booking.type === BookingType.Adhoc.ordinal
            ? `/privateBooking/${bookingId}/edit`
            : `/booking/${bookingId}/details`;
        row.relatedBooking = bookingId ? (
            <a href={bookingPath} style={{ color: "#1976d2", textDecoration: "none" }} onClick={e => e.stopPropagation()}>
                {bookingLabel}
            </a>
        ) : <span>{bookingLabel}</span>;

        row.status = this.renderStatusChip(ledger.status);

        row.actions = (
            <IconButton size="small" onClick={(e) => this.handleActionMenuOpen(e, ledger, null)} aria-label="actions">
                <MoreVertIcon fontSize="small" />
            </IconButton>
        );
        return row;
    };

    mapGroupedRow = (group, currencySymbol) => {
        if (!group) return null;
        const party = group.payee || group.payer || {};
        const name = party.profileName
            ? party.profileName
            : `${party.firstName || ""} ${party.lastName || ""}`.trim() || "Unknown";
        const totalFee = parseFloat(group.totalSuper || 0);
        const count = group.items ? group.items.length : 0;
        const items = group.items || [];
        let readyToPayDisplay;
        if (items.length === 0) {
            readyToPayDisplay = "—";
        } else {
            const rtpCount = items.filter(i => i.isReadyToPay).length;
            if (rtpCount === items.length) {
                readyToPayDisplay = (
                    <Tooltip title="All ledgers ready to pay">
                        <CheckCircleIcon style={{ color: "#4CAF50" }} />
                    </Tooltip>
                );
            } else if (rtpCount === 0) {
                readyToPayDisplay = (
                    <Tooltip title="No ledgers ready to pay">
                        <WarningIcon style={{ color: "#ff9800" }} />
                    </Tooltip>
                );
            } else {
                readyToPayDisplay = (
                    <Tooltip title={`${rtpCount} of ${items.length} ledgers ready to pay`}>
                        <span style={{ fontSize: 12, fontWeight: 600, color: "#f57c00" }}>{rtpCount}/{items.length}</span>
                    </Tooltip>
                );
            }
        }
        return {
            id: group.payeeId || group.payerId || group.id,
            _group: group,
            contactName: name,
            totalSuper: currencySymbol + currencyHelper.formatMoney(totalFee, 2),
            superAmount: currencySymbol + currencyHelper.formatMoney(totalFee, 2),
            ledgerCount: count,
            readyToPay: readyToPayDisplay,
            status: this.renderGroupStatusSummary(group),
            actions: (
                <IconButton size="small" aria-label="actions" onClick={(e) => this.handleActionMenuOpen(e, null, group)}>
                    <MoreVertIcon fontSize="small" />
                </IconButton>
            )
        };
    };

    render() {
        const { outgoingLedgers, showMoreOutgoing, isGrouped, statusFilter } = this.props.superLedgerStore;
        const { currentProfile } = this.props.profileStore;
        const currencySymbol = this.getCurrencySymbol();
        const { actionMenuAnchorEl } = this.state;
        const isMusician = currentProfile?.type === ProfileType.Musician.ordinal;
        const isSingleVenueStaff = currentProfile?.type === ProfileType.Staff.ordinal && !currentProfile?.hasOrganisation;
        const paymentType = isSingleVenueStaff
            ? (currentProfile?.venue?.paymentType ?? null)
            : (currentProfile?.paymentType ?? null);

        const filterControls = (
            <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 12, flexWrap: "wrap" }}>
                <FormControl style={{ minWidth: 180 }}>
                    <InputLabel shrink htmlFor="outgoing-status-filter">
                        Filter by Status&nbsp;
                        <Tooltip title="Filter ledgers by their payment status — Pending, Processing, Posted, Paid, Failed, or Refunded.">
                            <InfoIcon style={{ fontSize: 14, verticalAlign: "middle", color: "#9e9e9e", cursor: "help" }} />
                        </Tooltip>
                    </InputLabel>
                    <Select
                        displayEmpty
                        value={statusFilter === undefined || statusFilter === null ? "" : statusFilter}
                        onChange={this.handleStatusFilterChange}
                        inputProps={{ id: "outgoing-status-filter" }}
                    >
                        {STATUS_OPTIONS.map(opt => (
                            <MenuItem key={String(opt.value)} value={opt.value}>{opt.label}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControlLabel
                    control={
                        <Switch
                            checked={isGrouped}
                            onChange={this.handleGroupToggle}
                            color="primary"
                        />
                    }
                    label={isMusician ? "Group by Hirer" : "Group by Payer"}
                />
            </div>
        );

        if (isMusician) {
            const musicianColumns = this.getMusicianColumns(isGrouped);
            let rows;
            if (isGrouped) {
                rows = outgoingLedgers.map(g => this.mapGroupedRow(g, currencySymbol)).filter(Boolean);
            } else {
                rows = outgoingLedgers.map(l => this.mapLedgerRow(l, currencySymbol, paymentType)).filter(Boolean);
            }

            return (
                <Fragment>
                    <Grid container spacing={8}>
                        <Grid item xs={12} lg={12}>
                            <Typography variant="headline" component="h3" gutterBottom>
                                Super Owed to Me
                            </Typography>
                            <Typography gutterBottom className="side-helper-text">
                                Super amounts due to you from the hirer for bookings you performed.
                            </Typography>
                        </Grid>
                        <Grid item xs={12} lg={12}>
                            <Grid container spacing={16}>
                                <Grid item xs={12}>
                                    {filterControls}
                                    <Paper>
                                        <div style={{ overflowX: "auto" }}>
                                            <ResponsiveTable
                                                showToolbar={true}
                                                columns={musicianColumns}
                                                rows={rows}
                                                sortable={true}
                                                footerRow={this.renderMusicianFooterRow(rows, isGrouped)}
                                            />
                                        </div>
                                    </Paper>
                                    {!isGrouped && showMoreOutgoing && (
                                        <div style={{ textAlign: "center", padding: "16px" }}>
                                            <Button variant="outlined" onClick={this.handleLoadMore}>
                                                Load More
                                            </Button>
                                        </div>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Menu anchorEl={actionMenuAnchorEl} open={Boolean(actionMenuAnchorEl)} onClose={this.handleActionMenuClose}>
                        <MenuItem onClick={this.handleViewFromMenu}>View</MenuItem>
                    </Menu>
                </Fragment>
            );
        }

        const columns = this.getColumns(isGrouped);
        let rows;
        if (isGrouped) {
            rows = outgoingLedgers.map(g => this.mapGroupedRow(g, currencySymbol)).filter(Boolean);
        } else {
            rows = outgoingLedgers.map((ledger) => {
                if (!ledger) return null;
                const row = this.mapLedgerRow(ledger, currencySymbol, paymentType);
                if (!row) return null;

                row.totalSuper = currencySymbol + currencyHelper.formatMoney(parseFloat(ledger.superFee || 0), 2);

                const isSuperComplete = paymentType === 1
                    ? ledger.isSuperAnnuationCompleteXero
                    : ledger.isSuperAnnuationComplete;
                row.superDetails = isSuperComplete ? (
                    <Tooltip title="Super details added"><CheckCircleIcon style={{ color: "#4CAF50" }} /></Tooltip>
                ) : (
                    <Tooltip title={paymentType === 1 ? "Artist not yet set up in Xero" : "Super details not yet added"}>
                        <WarningIcon style={{ color: "#ff9800" }} />
                    </Tooltip>
                );

                const invoice = ledger.invoice || {};
                const isInvoicePaid = invoice.status === "paid" || !!ledger.isInvoicePaid;
                const notReadyReason = !isInvoicePaid
                    ? "Related outgoing invoice not yet paid"
                    : !isSuperComplete
                        ? paymentType === 1 ? "Artist not yet set up in Xero" : "Super details not yet added"
                        : "Not ready to pay";
                row.readyToPay = ledger.isReadyToPay ? (
                    <Tooltip title="Venue invoice is paid and super details are complete"><CheckCircleIcon style={{ color: "#4CAF50" }} /></Tooltip>
                ) : (
                    <Tooltip title={notReadyReason}><WarningIcon style={{ color: "#ff9800" }} /></Tooltip>
                );

                return row;
            }).filter(row => row !== null);
        }

        return (
            <Fragment>
                <Grid container spacing={8}>
                    <Grid item xs={12} lg={12}>
                        <Typography variant="headline" component="h3" gutterBottom>
                            Super Owed to Me
                        </Typography>
                        <Typography gutterBottom className="side-helper-text">
                            Super amounts due to you from the payer for bookings you arranged or supplied, where sole-trader performers triggered Super Guarantees.
                        </Typography>
                    </Grid>
                    <Grid item xs={12} lg={12}>
                        <Grid container spacing={16}>
                            <Grid item xs={12}>
                                {filterControls}
                                <Paper>
                                    <div style={{ overflowX: "auto" }}>
                                        <ResponsiveTable
                                            showToolbar={true}
                                            columns={columns}
                                            rows={rows}
                                            sortable={true}
                                            footerRow={this.renderFooterRow(outgoingLedgers, isGrouped)}
                                        />
                                    </div>
                                </Paper>
                                {!isGrouped && showMoreOutgoing && (
                                    <div style={{ textAlign: "center", padding: "16px" }}>
                                        <Button variant="outlined" onClick={this.handleLoadMore}>
                                            Load More
                                        </Button>
                                    </div>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Menu anchorEl={actionMenuAnchorEl} open={Boolean(actionMenuAnchorEl)} onClose={this.handleActionMenuClose}>
                    <MenuItem onClick={this.handleViewFromMenu}>View</MenuItem>
                </Menu>
            </Fragment>
        );
    }
}

export default OutgoingLedgers;
